export const handleOptionsToggle = (layoutOptions, currentToggle, toggleToBeEnabled) => {
  const enableToggle = (options, toggle) => {
    // eslint-disable-next-line security/detect-object-injection
    options[toggle].state = true
  }

  const isToggleArray = Array.isArray(toggleToBeEnabled)

  // eslint-disable-next-line security/detect-object-injection
  if (!layoutOptions[currentToggle].state) {
    if (!isToggleArray) {
      enableToggle(layoutOptions, toggleToBeEnabled)
    }
  }
  else if (isToggleArray) {
    toggleToBeEnabled.forEach(toggle => enableToggle(layoutOptions, toggle))
  }

  // eslint-disable-next-line security/detect-object-injection
  layoutOptions[currentToggle].state = !!layoutOptions[currentToggle].state

  // eslint-disable-next-line security/detect-object-injection
  if (!layoutOptions[currentToggle].state && layoutOptions.splitCodeIdAndName) {
    layoutOptions.splitCodeIdAndName.state = false
  }
}
